import {Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NbDialogService, NbToastrService} from '@nebular/theme';
import { MainService } from "../../services/main.service";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {LocalDataSource} from 'ng2-smart-table';
import * as S3 from "aws-sdk/clients/s3";
import * as moment from "moment";

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss']
})
export class UsuariosComponent implements OnInit {
  bucket: S3 = new S3({
    accessKeyId: "AKIAUT7IXVID4CI4XZVD",
    secretAccessKey: "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",
    region: "us-east-1"
  });
  /*  Para el modal */
  @ViewChild('dialog', {static: true}) dialog: ElementRef;
  frmUsuario: FormGroup;
  loading = false;
  submitted = false;
  imagen: any = [""];
  listaIMG: any[] = [];
  ListaFotos: any = [""];

  /*****/
  settings = {
    hideSubHeader: true,
    actions: {
      delete: false,
      edit: false,
      add: false,
      filter: false,
      custom: [
        {name: 'edit', title: '<i class="nb-compose"></i> ',},
        {name: 'delete', title: '<i class="nb-trash"></i> ',}
      ],
    },
    columns: {
      usualogin: {title: 'Usuario'},
      usua_nombres: {title: 'Nombre'},
      usua_apellidos: {title: 'Apellido'},
      usua_email: {title: 'Email'},
      usua_telefonos: {title: 'Telefono'},
      perfil: {title: 'Rol'},

    }
  };

  datos: any[];
  listaGrupos: any[];
  public source: LocalDataSource;
  constructor(private toastrService: NbToastrService,
              public router: Router,
              private dialogService: NbDialogService,
              public mainService: MainService,
              private rutaActiva: ActivatedRoute,
              public fb: FormBuilder) {
    this.getUsuario();
    this.getGrupos();
    this.frmUsuario = this.fb.group({
      cc: ['', [Validators.required]],
      usuario: [''],
      nombres: [''],
      apellidos: [''],
      email: [''],
      telefono: [''],
      rol: [''],
      tipo: [''],
      grupo: [''],
      direccion: [''],
  });
  console.log(moment(Date.now()).format())
  }

  ngOnInit() {
  }
  get valoresCrear() {
    return this.frmUsuario.controls;
  }
  /** Para modal **/
  getUsuario() {
    this.mainService.get("tadmUsuario").subscribe(result => {
      if (result) {
        console.log(result);
        this.datos = result;
        this.source = new LocalDataSource(this.datos);
      } else {
        console.log("Error al insertar en Sql");
      }
    });
  }
  getGrupos(){
    this.mainService.get('tadmSelectType/Grupo').subscribe(value => {
      console.log(value);
      this.listaGrupos = value;
    })
  }
  crear() {
    this.openDialogSave(this.dialog);
  }

  openDialogSave(dialog) {
    this.dialogService.open(dialog, { context: 'this is some additional data passed to dialog' });
  }

  accion() {
    this.loading = true;
    const TIME_IN_MS = 3000;
    setTimeout(() => {
      this.loading = false;
      this.showToast('top-right', 'success', 'Éxito!', 'Se ejecuto éxito!');
      const element: HTMLElement = document.getElementById('btn-close') as HTMLElement;
      element.click();
    }, TIME_IN_MS);
  }

  /** Toas **/
  showToast(position, status, titulo, mensaje) {
    this.toastrService.show(
      mensaje,
      titulo,
      { position, status });
  }
  readUrl(event: any) {
    this.imagen = event.target.files[0];
    console.log(this.imagen);
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.onload = (event: ProgressEvent) => {
        let img = { src: (<FileReader>event.target).result };
        this.listaIMG.push(img);
        //this.listaIMG[0].src = (<FileReader> event.target).result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }
  DeleteIMG() {
    this.listaIMG = [];
  }
  save() {
    this.loading = true;
    var params = {
      Bucket: "printech-resources",
      ACL: "public-read",
      Key: this.makeid(8) + this.imagen.name.trim(),
      ContentType: this.imagen.type,
      Body: this.imagen
    };
    var options = {
      // Part Size of 10mb
      partSize: 10 * 1024 * 1024,
      queueSize: 1,
      // Give the owner of the bucket full control
      ACL: "public-read"
    };
    const self = this;
    var uploader = this.bucket.upload(params, options, function(err, data) {
      if (err) {
        console.log("PERDIDAS");
        this.loadingImage = false;
      }
      console.log("SUCCESS");
      console.log(data);
      self.ListaFotos[0] = data.Location.toString();
      console.log(self.ListaFotos);
      self.saveUsuario();
    });
    uploader.on("httpUploadProgress", function(event) {
      console.log("UPDATE");
      console.log(event);
      var total = (event.loaded * 100) / event.total;
      console.log(total);
    });
    return;
  }
  saveUsuario() {
    this.submitted = true;
    if (this.frmUsuario.invalid) {
        return false;
    }
    let usu = this.frmUsuario.value;

    let insert = {
      usua_identifica: usu.cc,
      usualogin: usu.usuario,
      usua_nombres:usu.nombres,
      usua_apellidos:usu.apellidos,
      usua_email:usu.email,
      usua_telefonos:usu.telefono,
      perfil:usu.rol,
      //usu.tipo,
      usua_feccre:moment(Date.now()).format(),
      id_empresa:usu.grupo,
      usua_direccion: usu.direccion,
      id_imagen_mongo_usuario: this.ListaFotos[0],

    }
    console.log(insert);
    this.mainService.post('tadmUsuario', insert).subscribe(result => {
        console.log(result);
        if (result) {
            console.log('Se ha insertado');
            this.frmUsuario.reset();
            this.submitted = false;
            //this.spinner.hide();
            this.showToast('top-right', 'success', 'Success!', 'It was created successfully!');
            let element: HTMLElement = document.getElementById('btn-close-save') as HTMLElement;
            this.getUsuario();
            this.loading = false;
            element.click();
            return true;

        } else {
            console.log('Error');
            this.frmUsuario.reset();
            this.submitted = false;
            //this.spinner.hide();
            this.loading = false;
            this.showToast('top-right', 'warning', 'Error!', 'Error creating!');
            let element: HTMLElement = document.getElementById('btn-close-save') as HTMLElement;
            element.click();

            return false;
        }
    });
}
  makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  onCustom(event) {
    console.log(event);
    switch (event.action) {
        case 'edit':
          console.log(event.data.usua_identifica)
           this.verUsuario(event.data.usua_identifica);
            break;
        case 'delete':
            this.eliminar(event.data);
            break;
  
    }
  }
  verUsuario(id){
    this.router.navigate(['dashboard/editUsuarios', id]);
  }
  eliminar(data) {  
    this.loading = true;       
    this.mainService.delete('tadmUsuario/'+ data.usua_identifica).subscribe(result => {
        console.log(result);
        if (result.deleted) {
            console.log('Se ha eliminado');
            this.getUsuario();
            this.loading = false;       
            this.showToast('top-right', 'success', 'Success!', 'It was deleted');
  
        } else {
            console.log('Error');
            this.showToast('top-right', 'warning', 'Error!', 'Error deleting!');
        }
    });
     }
}
